import { Container as MuiContainer, ContainerProps as MuiContainerProps } from "@mui/material";

type ContainerProps = MuiContainerProps & {
  children: React.ReactNode;
};

const Container = ({ children, ...props }: ContainerProps) => {
  return <MuiContainer {...props}>{children}</MuiContainer>;
};

export default Container;
